import getClient from 'utilities/startplusGraphql';
import { Queries } from 'apollo';
import Logger from 'utilities/logger';

const useGetSupportingDocumentFile = async ({ fileId, isPreview }) => {
  const logger = Logger('MyFiles.uploadMyFile');
  const startPlusClient = await getClient();
  const response = await startPlusClient.query({
    query: Queries.GetMySupportingDocumentFile,
    variables: { id: fileId },
    fetchPolicy: 'no-cache',
  });
  const { myFile } = response.data;
  logger.debug(myFile);
  const { getUrl: url } = myFile;
  if (isPreview) {
    // Return pdf viewer 'file'
    return { url, withCredentials: false };
  }
  // Return downloader url
  return url;
};

export default useGetSupportingDocumentFile;
